

angular.module('CarsSaraBo').controller('AuditController', ['$scope', '$interpolate',  function($scope, $interpolate) {
	
	$scope.initialize = function() {
		$scope.actions = [
{
action: "POINTS_OF_SALE_CHANGE",
user: "aszneiberg.ar",
date: "2015-01-21T20:40:45Z",
parameters: {
businessHours: "MONDAY-00-24 | TUESDAY-00-24 | WEDNESDAY-00-24 | THURSDAY-00-24 | FRIDAY-00-24 | SATURDAY-00-24 | SUNDAY-00-24 ",
name: "PV4",
action: "ADD"
}
},
{
action: "AVAILABILITY_CHANGE",
user: "aszneiberg.ar",
date: "2015-01-20T17:31:35Z",
parameters: {
contract: "502",
pointsOfSale: "683 ",
period: "20150120 - 20160131",
daysOfWeek: "MONDAY | TUESDAY | WEDNESDAY | THURSDAY | FRIDAY | SATURDAY | SUNDAY ",
selectedCategories: "2382:10|2380:10|2381:10|2377:1"
}
},
{
action: "PUBLISH_CONTRACT",
user: "aszneiberg.ar",
date: "2015-01-20T17:31:04Z",
parameters: {
value: "true"
}
},
{
action: "POINTS_OF_SALE_CHANGE",
user: "aszneiberg.ar",
date: "2015-01-20T14:12:06Z",
parameters: {
businessHours: "MONDAY-00-24 | TUESDAY-00-24 | WEDNESDAY-00-24 | THURSDAY-00-24 | FRIDAY-00-24 | SATURDAY-00-24 | SUNDAY-00-24 ",
name: "PV3",
action: "ADD"
}
},
{
action: "POINT_OF_SALE_REMOVE",
user: "aszneiberg.ar",
date: "2015-01-13T15:04:19Z",
parameters: {
businessHours: "",
name: "Cordoba",
action: "DELETE"
}
}
]
		
		$scope.actionDescriptions = {
				POINTS_OF_SALE_CHANGE: "made a change in the point of sale {{name}}.",
				POINT_OF_SALE_REMOVE: "removed the point of sale '{{name}}'.",
				PUBLISH_CONTRACT: "changed a contract publication status to {{published ? 'PUBLISHED' : 'NOT PUBLISHED'}}.",
				AVAILABILITY_CHANGE: "changed availability for period {{period}}."
		};
		
		
	}
	
	
	
	
	$scope.descriptionFor = function(actionType) {
		return $interpolate($scope.actionDescriptions[actionType] || "");
	}
	
	$scope.initialize();
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/audit_controller.js
// module id = 896
// module chunks = 3